import React, { FC, useState } from "react";
import TableTopProduct from "./ChartTopProduct";
import styled from "@emotion/styled";
import RightSelect from "./ChartTopProduct/RightSelect";

interface TableSectionProps {
  daterangePicker: [string, string]
}
const TableSection:FC<TableSectionProps> = ({ daterangePicker }) => {


  const [selectPeriod, setSelectPeriod] = useState('')

  return (
    <>
      <WrapperCardMid>
        {/* <WrapperHearder>
          <TextHeader>5 สินค้าขายดี</TextHeader>
          <RightSelect setSelectPeriod={setSelectPeriod} />
        </WrapperHearder> */}
      </WrapperCardMid>
      <TableTopProduct selectPeriod={selectPeriod}  daterangePicker={daterangePicker} />
    </>
  );
};

export default TableSection;

const WrapperCardMid = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background-color: #efefef;
  height: 20px;
  padding-left: 10px;
`;

const WrapperHearder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const TextHeader = styled.p`
  font-size: 18px;
  font-weight: 600;
`;
